<template>
    <modal @close="cancelClick" class="edit-modal" hideFooter id="edit-company-address">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Company Information</h3>
                    <p>
                        To ensure we always provide you with the best service and most accurate information, please take a moment to review and update your company details. Keeping your information current helps us tailor our offerings, streamline our communication, and ensure seamless service delivery.
                    </p>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Company Information</h3>
                    <div class="md-col-2">
                        <div class="column">
                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Name:</label>
                                <input v-model="update.name" type="text" placeholder="" />
                                <p v-if="v$.name.$error" class="td-error">Company Name is required.</p>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Email:</label>
                                <input v-model="update.email" type="text" placeholder="" />
                                <p v-if="v$.email.$error" class="td-error">Email is in an invalid format.</p>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Office #:</label>
                                <input v-model="update.officeNumber" type="text" placeholder="" />
                                <p v-if="v$.officeNumber.$error" class="td-error">Office # is required.</p>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Fax #:</label>
                                <input v-model="update.faxNumber" type="text" placeholder="" />
                                <p v-if="v$.faxNumber.$error" class="td-error">Fax # is in an invalid format.</p>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Website:</label>
                                <input v-model="update.website" type="text" placeholder="" />
                                <p v-if="v$.website.$error" class="td-error">Website is in an invalid format.</p>
                            </div>
                        </div>
                        <div class="column">


                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="cancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="saveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditCompanyInfo';
    export default script;
</script>
<style lang="less">
    @import './EditCompanyInfo.less';
</style>